const minxin = {
  methods: {
    imgTouchstart(url) {
      console.log('?????');
      window.parent.postMessage(JSON.stringify({ state: 1, url }), '*')
    },
    imgTouchend() {
      console.log('!!!!!');
      window.parent.postMessage(JSON.stringify({ state: 2 }), '*')
    },
  },
}
export default minxin